import './style.scss';

export function landing_hero_block() {
    const block = document.querySelector('.landing_hero_block');
    if (!block) return;

    const videoBtn = block.querySelector('.profile-thumb');
    const modal = block.querySelector('.video-modal');
    const closeBtn = block.querySelector('.close-modal');

    if (!videoBtn || !modal || !closeBtn) return;

    const mediaElement = modal.querySelector('video, iframe');

    if (!mediaElement) return;

    const openModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        modal.classList.add('show');
        document.documentElement.classList.add('modal-opened');

        if (mediaElement.tagName === 'VIDEO') {
            mediaElement.play().catch(() => { });
        } else if (mediaElement.tagName === 'IFRAME') {
            if (mediaElement.id === 'vimeo') {
                mediaElement.contentWindow.postMessage('{"method":"play"}', '*');
            } else if (mediaElement.id === 'youtubeVideo') {
                mediaElement.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            }
        }
    };

    const closeModal = () => {
        modal.classList.remove('show');
        document.documentElement.classList.remove('modal-opened');

        if (mediaElement.tagName === 'VIDEO') {
            mediaElement.pause();
        } else if (mediaElement.tagName === 'IFRAME') {
            if (mediaElement.id === 'vimeo') {
                mediaElement.contentWindow.postMessage('{"method":"pause"}', '*');
            } else if (mediaElement.id === 'youtubeVideo') {
                mediaElement.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            }
        }
    };

    videoBtn.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', (e) => {
        if (!e.target.closest('video') && !e.target.closest('iframe')) {
            closeModal();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('show')) {
            closeModal();
        }
    });
}
